import { postRequest, patchRequest, deleteRequest } from "@react/helpers/fetch"

export const createExpense = (projectId, body) =>
  postRequest({ url: `/projects/${projectId}/expenses.json`, body: { expense: body } })

export const updateExpense = (projectId, id, body) =>
  patchRequest({ url: `/projects/${projectId}/expenses/${id}.json`, body: { expense: body } })

export const destroyExpense = (projectId, id) =>
  deleteRequest(`/projects/${projectId}/expenses/${id}.json`)
